const init = new Initializer(),
  DOM = {
    INDEX_TABLE_CONTAINTER: '#ownership-transfers-table-container',
    INDEX_TABLE_BODY: 'table.collection#ownership-transfers-table tbody',
  },
  OWNERSHIP_TRANSFERS_CHANNEL_PREFIX = `/${currentCustomer}/ownership_transfers`,
  CHANNEL_SUBSCRIPTIONS = {};

const rowClick = function (event) {
  const row = event.target.closest('tr');

  if (row === null) {
    return;
  }

  Turbolinks.visit(row.getAttribute('href'));
};

const bindRowsClick = function (containerElement) {
  if (containerElement === null) {
    return;
  }

  const tableBody = containerElement.querySelector(DOM.INDEX_TABLE_BODY);

  tableBody.removeEventListener('click', rowClick);
  tableBody.addEventListener('click', rowClick);
};

const isActiveTransferRow = function (row) {
  const statusCell = row.querySelector('td.status');

  return (
    statusCell !== null &&
    !['Success', 'Failed'].includes(statusCell.textContent)
  );
};

const activeOwnershipTransfers = function () {
  return Array.from(
    document.querySelectorAll(
      `${DOM.INDEX_TABLE_CONTAINTER} ${DOM.INDEX_TABLE_BODY} tr`,
    ),
  )
    .filter((row) => isActiveTransferRow(row))
    .flatMap((row) => row.dataset.id);
};

const processUpdates = function (ownershipTransferData) {
  const row = document.querySelector(
    `#ownership-transfer-${ownershipTransferData.id}`,
  );

  const noStepChange =
      ownershipTransferData.current_step_index == row.dataset.stepIndex,
    noStatusChange =
      ownershipTransferData.status ==
      row.querySelector('td.status').textContent;
  if (noStepChange && noStatusChange) {
    return;
  }

  row.dataset.inProgress = 'true';
  htmx
    .ajax(
      'GET',
      `${window.location.pathname}/${ownershipTransferData.id}/row`,
      {
        target: row,
        swap: 'outerHTML',
      },
    )
    .then(() => {
      delete row.dataset.inProgress;
    })
    .catch(() => {
      delete row.dataset.inProgress;
    });
};

const subscribeToAllActiveUpdatesChannels = function () {
  const actives = activeOwnershipTransfers(),
    unsubscribes = Object.keys(CHANNEL_SUBSCRIPTIONS).filter(
      (subscription) => !actives.includes(subscription),
    );

  for (const ownershipTransferId of unsubscribes) {
    unsubscribeToUpdatesChannel(ownershipTransferId);
  }

  for (const ownershipTransferId of actives) {
    subscribeToUpdatesChannel(ownershipTransferId);
  }
};

const subscribeToUpdatesChannel = function (ownershipTransferId) {
  if (CHANNEL_SUBSCRIPTIONS[ownershipTransferId] !== undefined) {
    return;
  }

  CHANNEL_SUBSCRIPTIONS[ownershipTransferId] = Messenger.on(
    `${OWNERSHIP_TRANSFERS_CHANNEL_PREFIX}/${ownershipTransferId}`,
    processUpdates,
  );
};

const unsubscribeToUpdatesChannel = function (ownershipTransferId) {
  if (CHANNEL_SUBSCRIPTIONS[ownershipTransferId] === undefined) {
    return;
  }

  Messenger.off(
    `${OWNERSHIP_TRANSFERS_CHANNEL_PREFIX}/${ownershipTransferId}`,
    processUpdates,
  );
  delete CHANNEL_SUBSCRIPTIONS[ownershipTransferId];
};

const updateRowChannelSubscription = function (row) {
  if (isActiveTransferRow(row)) {
    subscribeToUpdatesChannel(row.dataset.id);
  } else {
    unsubscribeToUpdatesChannel(row.dataset.id);
  }
};

module.exports = function () {
  document.addEventListener(
    'turbolinks:before-visit',
    () => {
      for (const ownershipTransferId of Object.keys(CHANNEL_SUBSCRIPTIONS)) {
        unsubscribeToUpdatesChannel(ownershipTransferId);
      }
    },
    { once: true },
  );

  $(DOM.INDEX_TABLE_CONTAINTER).on('htmx:afterSwap', (event) => {
    init.register();

    if (event.target instanceof HTMLTableRowElement) {
      updateRowChannelSubscription(event.target);
    } else {
      subscribeToAllActiveUpdatesChannels();
      bindRowsClick(event.target);
    }
  });

  subscribeToAllActiveUpdatesChannels();
  bindRowsClick(document.querySelector(DOM.INDEX_TABLE_CONTAINTER));
};
